var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #6c9;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "livetype"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "19 11.15 19 19.41 25.58 25.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,36.5c-2.42,0-4.7-.46-6.83-1.38-2.13-.92-3.98-2.17-5.56-3.74-1.58-1.57-2.82-3.43-3.74-5.56-.92-2.13-1.38-4.4-1.38-6.82,0-2.42,.46-4.7,1.38-6.83,.92-2.13,2.17-3.98,3.74-5.56,1.57-1.58,3.43-2.82,5.56-3.74,2.13-.92,4.4-1.38,6.82-1.38s4.7,.46,6.83,1.38c2.13,.92,3.98,2.17,5.56,3.74,1.58,1.57,2.82,3.43,3.74,5.56,.92,2.13,1.38,4.4,1.38,6.82s-.46,4.7-1.38,6.83c-.92,2.13-2.17,3.98-3.74,5.56-1.57,1.58-3.43,2.82-5.56,3.74-2.13,.92-4.4,1.38-6.82,1.38Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.bbe59288bff8a66f3f0cd86368b9d448.svg";
export { ForwardRef as ReactComponent };